import cleanedFilename from '~/util/cleanedFilename';

export default {
  NIEUW_BADGE: `${cleanedFilename(__filename)}-nieuw-badge`,
};
